import React, { Component } from 'react';

import { SalesContext } from '../../Context/SalesContext';

import Back from '../Common/Back/Back';
import { getVumareachOfferDetails } from '../../Services/Services';

import {
  getDrivePackageImageURL,
  addBeforeloadEvent,
  removeBeforeloadEvent,
  getEnv
} from '../../Utility/utility';

import {
  tagOnVumatelPageLoad,
  tagOnVumatelAddressConfirmation,
  tagOnSetVumareachPreferredPaymentMethod,
  tagOnVumatelPaymentDate,
  tagOnVumatelErrorPopup
} from './../../Tagging/VumareachTagging';

import { VumaAddressSelector } from './components/VumaAddressSelector';
import { PaymentOptionCard } from './components/PaymentOptionCard';

import './VumaPlanDetails.css';

const Sales_Base_Url = `https://content${getEnv()}.vodacom.co.za/content/fibre/sales/images/`

class PlanDetails extends Component {
  static contextType = SalesContext;

  state = {
    packageProviderImg: '',
    selectedPackage: {},
    additionalServices: null,
    selectedTerm: '',
    totalMonthlyCost: null,
    totalOnceOffCost: null,
    recurringObject: [],
    voucherObject: [],

    selectedAddress: null,
    selectedPaymentDuration: null,
    hasError: false,
    paymentOptions: [
      {
        id: 1,
        name: '28 Day Prepaid Voucher',
        optionName: "Voucher",
        optionsTitle: 'You need a voucher for?',
        priceTitle: 'Total amount due: ',
        imgIconSrc: `${Sales_Base_Url}sales-vuma-vchr.png`,
        inclusions: ['20 Mbps Uncapped & unshaped Fibre service', 'Free Wi-Fi enabled router', 'Valid for a period of 28 Days (Once-Off)'],
        description: 'Purchase prepaid fibre for a 28-day period. For your convenience, you can buy up to six vouchers at a time using your EasyPay reference or PayFast link.'
      },
      {
        id: 2,
        name: 'Monthly Recurring Prepaid Voucher',
        optionName: "Recurring",
        optionsTitle: 'Choose a monthly debit order date',
        priceTitle: 'Monthly payment: ',
        imgIconSrc: `${Sales_Base_Url}sales-vuma-rec.png`,
        inclusions: ['20 Mbps Uncapped & unshaped Fibre service', 'Free Wi-Fi enabled router', 'Valid for a period of a month and it will be recurring on a monthly basis.'],
        description: 'Purchase prepaid fibre using your bank card. For your convenience, this is a once-off process via PayFast and the amount will be auto-debited monthly on the date you choose.'
      }
    ]
  };

  handleUpdateAddress = (addressLine) => {
    this.context.setInstallationAddress(addressLine);
  }

  addressApiProgressHandler = progress => {
    if (progress === 'error') {
      this.context.setShowSpinner(false);
      this.setState({ hasError: true });
    }
  }

  initialiseState = async () => {

    const { selectedPackage } = this.context;
    if (!selectedPackage) {
      return;
    }
    this.context.setShowSpinner(true);

    const packageProviderImg = getDrivePackageImageURL(selectedPackage.provider);

  this.setState({ selectedPaymentDuration: this.context.vumaPaymentOption });
  this.context.setShowSpinner(false);

  var recurringObject = [];
  var voucherObject = [];

  for (let i = 0; i < this.context.selectedPackage.contractTerms.length; i++) {
    let currentObject = this.context.selectedPackage.contractTerms[i];

    if (currentObject.offerType === "RECURRING") {
      recurringObject.push(currentObject);
    }
    else {
      voucherObject.push(currentObject);
    }
  }

  this.setState({
    voucherObject: voucherObject,
    recurringObject: recurringObject
  })

    this.setState({
      packageProviderImg,
      selectedPackage,
      selectedAddress: this.context.vumaInstallationAddress
    });
  }

  OnProductSelect = () => {
    let totalCost = 0;
    for (let i = 0; this.context.additionalServices && i < this.context.additionalServices.length; i++) {
      if (this.context.additionalServices[i].selectedProductPrice) {
        totalCost += parseInt(this.context.additionalServices[i].selectedProductPrice);
      }
    }
    totalCost += parseInt(this.context.selectedPackage.productPrice.value);
    this.setState({
      totalMonthlyCost: totalCost
    })
  }


  componentWillUnmount = () => {
    removeBeforeloadEvent();
  }

  componentDidMount = () => {

    addBeforeloadEvent();
    if (this.context.selectedPackage === null) {
      this.props.history.push('/cloud/fibre/sales/choosePlan');
      return;
    }
    tagOnVumatelPageLoad(this.context.selectedPackage.provider + ' - ' + this.context.selectedPackage.description, this.context.selectedPackage.price);

    this.initialiseState();

    if (this.context.selectedPackage)
      // tagOnFibrePlanDetails(this.context.selectedPackage.provider + ' - ' + this.context.selectedPackage.description, 1, this.context.selectedPackage.price);

      if (this.context.selectedContractTerm && this.state.selectedTerm !== this.context.selectedContractTerm.offerId) {
        this.setState({
          selectedTerm: this.context.selectedContractTerm.offerId
        });
      }
    this.OnProductSelect();
  }

  paymentMethodChangeHandler = method => {
    this.context.setVumaPaymentMethod(method);
    tagOnSetVumareachPreferredPaymentMethod();

    if (method.optionName === "Voucher") {
      this.context.setVumaProductType("VOUCHER");
    } else {
      this.selectPaymentMethod(null);
    }
  }

  addressChangeHandler = value => {
    tagOnVumatelAddressConfirmation();
    this.context.setVumaInstallationAddress(value);
  }

  selectPaymentMethod = input => {

    if (this.state.selectedPaymentDuration == input) {
      this.setState({selectedPaymentDuration: null});
      return;
    }

    this.setState({selectedPaymentDuration: input});
    this.context.setVumaPaymentOption(input);

    if (input === null) {
      this.context.setSelectedVumaProduct(null);
      return;
    }

    tagOnVumatelPaymentDate();

    if (input?.offerType === "VOUCHER") {
      this.context.setSelectedVumaProduct(input);
      this.context.setVumaSelectedProductID(input.offeringID)
      this.context.setSelectedVumaContractTerms(input)
      this.context.setVumaProductType("VOUCHER")
    } else {
      const selectedProduct = { ...this.state.recurringObject[0]};
      selectedProduct.selectedDebitOrderDate = input;
      this.context.setVumaSelectedProductID(selectedProduct.offeringID)
      this.context.setSelectedVumaContractTerms(selectedProduct)
      this.context.setSelectedVumaProduct(selectedProduct);
      this.context.setVumaProductType("RECURRING");
    }
  }

  render() {

    if (this.state.hasError) {
      const errorMsg = 'We are unable to get address information due to technical error. Please try again.';
      this.context.setErrorObject({ message: errorMsg });
      tagOnVumatelErrorPopup(errorMsg);
      this.props.history.push('/cloud/fibre/sales/error');
      return null;
    }

    const {
      packageProviderImg,
      selectedPackage,
    } = this.state;

    if (this.context.selectedPackage === null) {
      this.props.history.push('/cloud/fibre/sales/choosePlan');
      return null;
    }

    let price = null;
    if (this.context.vumaPaymentMethod && this.state.selectedPaymentDuration) {
      if (this.context.vumaPaymentMethod.optionName === "Recurring") {
        price = this.context.selectedPackage?.productPrice.value;
      } else {
        // const voucherCount = parseInt(this.state.selectedPaymentDuration.voucherCount.split(/ /)[0].replace(/[^\d]/g, '')) || 1;
        price = this.context.selectedPackage?.productPrice.value;
        // priceDetails = `(R ${this.state.selectedPaymentDuration.price / voucherCount} x ${voucherCount})`;
      }
    }

    let paymentSelectionMethodUI = null;
    paymentSelectionMethodUI = (
      this.context.vumaPaymentMethod && <div className="vumareach-plan-details-payment-options" automationid="SalesLead_Div_VPD_333">
        {
          null 
        }
        {
          this.context.vumaPaymentMethod.optionName === "Recurring" ?
          this.state.recurringObject[0].availableDebitOrderDate.map(item =>
              <span
                automationid={`SalesLead_Span_VPD${item}_01`}
                key={item}
                onClick={this.selectPaymentMethod.bind(this, item)}
                style={item === this.state.selectedPaymentDuration ? { background: "#000", color: "#fff" } : null}
                className="vumareach-plan-details-payment-option-item"
              >
                {item}
              </span>
            )  :
            this.state.voucherObject.map(item =>
              <span
                automationid={`SalesLead_Span_VPD${item.offeringID}_01`}
                key={item.offeringID}
                onClick={this.selectPaymentMethod.bind(this, item)}
                style={this.state.selectedPaymentDuration && item.offeringID === this.state.selectedPaymentDuration.offeringID? { background: "#000", color: "#fff" } : null}
                className="vumareach-plan-details-payment-option-item"
              >
                {item.voucherCount}
              </span>
            )
        }

        {price && <p automationid="SalesLead_P_PlanDetailsCardLogo_545" className="vumareach-plan-details-payment-price-container">
          Total amount due:
        <span style={{ fontWeight: "bold", marginLeft: "3rem" }} automationid="SalesLead_Span_PlanDetailsCardLogo_1001">
            <span style={{ textAlign: "center" }} automationid="SalesLead_Span_PlanDetailsCardLogo_1002">
              <span style={{ marginRight: "0.25rem" }} automationid="SalesLead_Span_PlanDetailsCardLogo_1003">{'R' + price}</span>
            </span>
          </span>
        </p>}
      </div>
    );


    return (
      <div automationid="SalesLead_Div_VPD_01">
        <div className="vuma-plan-details-page-wrapper" automationid="SalesLead_Div_VPD_02">
          <h1 className='plan-details-heading' automationid="SalesLead_Div_PlanDetailsHeading_0">Fibre Plan details</h1>
          <div className='plan-details-summery-card' automationid="SalesLead_Div_VPD_03">
            <div className="vuma-plan-details-header" automationid="SalesLead_Div_VPD_04">
              <div className='card-header-title-container' automationid="SalesLead_Div_PlanDetailsCardTitle_0">
                <div className="card-header-provider-logo" automationid="SalesLead_Div_PlanDetailsCardLogo_0">
                  <img
                    src={packageProviderImg}
                    alt='Package Provider'
                    automationid="SalesLead_Div_PlanDetailsCardLogoImage_0"
                  />
                </div>

                <div className='card-header-info' automationid="SalesLead_Div_PlanDetailsCardInfo_0">
                  <p className='card-header-title' automationid="SalesLead_Paragraph_PlanDetailsCardHeaderTitle_0">
                    {
                      selectedPackage.dataCap && selectedPackage.dataCap.toLowerCase() === "capped" ?
                        `${selectedPackage.dataCap} ${selectedPackage.dataCap}`
                        :
                        `${selectedPackage.dataCap}`
                    }
                  </p>
                  <p automationid="SalesLead_Div_PlanDetailsCardSpeed_0">
                    {`Speed: ${selectedPackage.download && selectedPackage.download.split(/ /)[0].replace(/[^\d]/g, '')}/${selectedPackage.upload}`}
                  </p>
                </div>

              </div>
              <div className='card-header-suffix card-header-suffix-top' automationid="SalesLead_Div_VPD_10">
                <p automationid="SalesLead_Paragraph_PlanDetailsCardPrice_0"> R{this.context.selectedPackage.productPrice.value} PM </p>
              </div>
            </div>
            <div className="vumareach-plan-details-section" automationid="SalesLead_Div_VPD_11">
              <h3 automationid="SalesLead_H3_VPD_01">What is Prepaid Fibre?</h3>
              <p automationid="SalesLead_P_VPD_12">
                It is a Fibre plan that allows the customer to control the use of data by paying before using the service.
                The Prepaid Fibre Plan is payable via the debit or credit card.
              </p>
            </div>
            <div className="vumareach-plan-details-section" automationid="SalesLead_Div_VPD_21">
              <VumaAddressSelector
                installationAddress={this.context.installationAddress}
                selectedAddress={this.context.vumaInstallationAddress ? this.context.vumaInstallationAddress.name : null}
                addressChangeHandler={this.addressChangeHandler}
                updateProgress={this.addressApiProgressHandler}
                setLoader={state => this.context.setShowSpinner(state)}
                provider={this.context.selectedPackage.provider}
              />
            </div>
            <div className="vumareach-plan-details-section" style={{ border: "none" }} automationid="SalesLead_Div_VPD_31">
              <h3 style={{ fontSize: "1rem" }} automationid="SalesLead_H3_VPD_31">Choose your product option</h3>

              <div className="vumareach-plan-details-payment-methods" automationid="SalesLead_Div_VPD_32">
                <PaymentOptionCard
                  selected={this.context.vumaPaymentMethod && this.context.vumaPaymentMethod.optionName}
                  clicked={this.paymentMethodChangeHandler}
                  option={this.state.paymentOptions[0]}
                />
                <div className="vumareach-plan-details-payment-type-container-mobile" style={{ marginBottom: "1rem" }} automationid="SalesLead_Div_PlanDetailsCardLogo_200">
                  {
                    this.context.vumaPaymentMethod &&
                    this.context.vumaPaymentMethod.optionName &&
                    this.context.vumaPaymentMethod.optionName === this.state.paymentOptions[0].optionName &&
                    paymentSelectionMethodUI
                  }
                </div>
                <PaymentOptionCard
                  selected={this.context.vumaPaymentMethod && this.context.vumaPaymentMethod.optionName}
                  clicked={this.paymentMethodChangeHandler}
                  option={this.state.paymentOptions[1]}
                />
              </div>
              <div className="vumareach-plan-details-payment-type-container-mobile" automationid="SalesLead_Div_PlanDetailsCardLogo_330">
                {
                  this.context.vumaPaymentMethod &&
                  this.context.vumaPaymentMethod.optionName &&
                  this.context.vumaPaymentMethod.optionName === this.state.paymentOptions[1].optionName &&
                  paymentSelectionMethodUI
                }
              </div>
              <div className="vumareach-plan-details-payment-type-container-desktop" automationid="SalesLead_Div_PlanDetailsCardLogo_454">{paymentSelectionMethodUI}</div>

            </div>
          </div>
        </div>
        <div>
          <Back
            submitClick={this.submitFormClickHandler}
            buttonName="CONTINUE"
            nextUrl="/cloud/fibre/sales/vumaContactInformation"
            enabledButton={Boolean(this.state.selectedPaymentDuration && this.context.vumaInstallationAddress)}
            automationidattr={`FibreAddress`}
            backUrl= "/cloud/fibre/sales/choosePlan"
          // totalMonthlyCost={this.state.totalMonthlyCost}
          />
        </div>
      </div>
    )
  }
}

export default PlanDetails;